import { t } from "@/i18n-js/instance";

const displayPriceType = (priceType: string, intervalLabel?: string) =>
  priceType === "subscription"
    ? `${intervalLabel || ""} ${t("settings.paywall_prices.subscription_item_text")}`
    : intervalLabel || "";

const amountFormatter = (amount: number) => {
  amount = amount / 100;

  return (
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: amount % 1 == 0 ? 0 : 2,
    }).format(amount) + " USD"
  );
};

const displayAmount = (
  amount: number,
  interval?: string,
  intervalCount?: number,
) => {
  let formattedAmount = amountFormatter(amount);

  if (!interval) {
    return formattedAmount;
  }
  formattedAmount += " / ";
  formattedAmount += t(`settings.paywall_prices.interval_labels.${interval}`, {
    count: intervalCount || 1,
  });
  return formattedAmount;
};

export interface PaywallPriceElementProps {
  allowPreferredAction: boolean;
  amount: number;
  interval?: string;
  intervalCount?: number;
  intervalLabel?: string;
  onRemove: () => void;
  onSetPreferred: () => void;
  preferred: boolean;
  priceType: string;
}

export const PaywallPriceElement = ({
  priceType,
  interval,
  intervalCount,
  intervalLabel,
  amount,
  preferred,
  allowPreferredAction,
  onRemove,
  onSetPreferred,
}: PaywallPriceElementProps) => (
  <div className="border-secondary flex items-center border-b px-5 py-3.5 last:border-b-0">
    <div className="grow text-left">
      <div className="text-sm font-bold">
        {displayPriceType(priceType, intervalLabel)}
      </div>
      <div className="text-sm">
        {displayAmount(amount, interval, intervalCount)}
      </div>
    </div>
    <div className="flex font-bold">
      {!preferred && allowPreferredAction && (
        <button
          type="button"
          className="btn-link label-negative focus-visible:!outline-secondary mr-5 cursor-pointer focus-visible:!outline focus-visible:!outline-2 focus-visible:!outline-offset-2"
          onClick={onSetPreferred}
        >
          {t("settings.paywall_prices.buttons.make_preferred")}
        </button>
      )}
      {preferred && (
        <button
          type="button"
          className="label-positive focus-visible:!outline-secondary mr-5 cursor-pointer focus-visible:!outline focus-visible:!outline-2 focus-visible:!outline-offset-2"
          onClick={onSetPreferred}
        >
          {t("settings.paywall_prices.form.preferred_label")}
        </button>
      )}
      <button
        type="button"
        className="btn-link focus-visible:!outline-secondary cursor-pointer text-sm text-red-400 focus-visible:!outline focus-visible:!outline-2 focus-visible:!outline-offset-2"
        onClick={onRemove}
      >
        {t("settings.paywall_prices.buttons.remove")}
      </button>
    </div>
  </div>
);
